const helpLinks = {
  iFrameImplementation: 'https://hilfe.bottimmo.com/portal/de/kb/articles/wie-kann-ich-die-bottimmo-inhalte-auf-meiner-wordpress-website-integrieren',
  customUrl: 'https://hilfe.bottimmo.com/portal/de/kb/articles/custom-urls'
}
export default helpLinks
